import { render, staticRenderFns } from "./customerDppm.vue?vue&type=template&id=83798e98&scoped=true&"
import script from "./customerDppm.vue?vue&type=script&lang=js&"
export * from "./customerDppm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83798e98",
  null
  
)

export default component.exports